import React from "react"

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: string | number
  color?: string
  title?: string
}

export const MdTextFields: React.FC<IconProps> = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 24 24"
      height={size}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {title && <title>{title}</title>}
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z" />
    </svg>
  )
}

export default MdTextFields
